(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo"] && !Shopify.designMode) return;
  try {
    
  class CollectionSeo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.content = this.querySelector('[data-collection-seo-content]');
      this.button = this.querySelector('[data-collection-seo-toggle]');
      this.label = this.querySelector('[data-collection-seo-label]');

      if (!this.content || !this.button) return;

      const collapsedHeight = Number(this.dataset.collapsedHeight) || 120;
      if (this.content.scrollHeight <= collapsedHeight + 8) {
        this.button.hidden = true;
        this.classList.add('is-expanded');
        return;
      }

      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const expanded = this.classList.toggle('is-expanded');
      this.button.setAttribute('aria-expanded', String(expanded));
      if (this.label) {
        this.label.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
      }
    }
  }

  if (!customElements.get('collection-seo')) {
    customElements.define('collection-seo', CollectionSeo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
